module.exports = __webpack_public_path__ + "img/1-230109102A5I2.3ca6e523.gif";